import { useCallback, useEffect, useState } from "react";

const getRemainingSeconds = (endsAt: number, now: number) =>
    Math.max(0, Math.ceil((endsAt - now) / 1000));

export default function useCooldown(durationSeconds: number) {
    const [endsAt, setEndsAt] = useState(0);
    const [now, setNow] = useState(Date.now());
    const remainingSeconds = getRemainingSeconds(endsAt, now);

    useEffect(() => {
        if (remainingSeconds === 0) {
            return undefined;
        }

        const timerId = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(timerId);
    }, [remainingSeconds]);

    const start = useCallback(() => {
        const nextNow = Date.now();
        setNow(nextNow);
        setEndsAt(nextNow + durationSeconds * 1000);
    }, [durationSeconds]);

    const reset = useCallback(() => {
        setNow(Date.now());
        setEndsAt(0);
    }, []);

    return {
        isCoolingDown: remainingSeconds > 0,
        remainingSeconds,
        reset,
        start,
    };
}
